// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e_-A","legend":"e_aB","legendContent":"e_bB","contentWrapper":"e_cB","fieldsetContent":"e_dB"};